// Is a given variable undefined?
export default function isUndefined(obj) {
  return obj === void 0;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isUndefined.js
// module id = 162
// module chunks = 0 1